export default __webpack_public_path__ + "static/media/(16).4f88a8b9.jpg";